const $ = require("jquery");
import "magnific-popup";

import template from "./skyfish-media.vhtml";
import QdSelectBox from "../select-box/select-box.js";
import QdIcon from "../icon/icon.js";
import { RestComponent } from "../../mixins/rest-component";

// Disable eslint indentation rule
/* eslint indent: ["error", 2, { "ignored": ["template"] }] */

export default {
  template: template,
  components: {
    QdSelectBox,
    RestComponent,
    QdIcon,
  },
  props: {
    mediaItem: {
      type: Object,
      default: null,
    },
    color: {
      type: String,
      default: "",
    },
    fallbackImage: {
      type: String,
      default: "",
    },
  },
  data: () => ({}),
  computed: {
    isVideo() {
      return this.mediaItem.mimetype.includes("video");
    },
    isPPT() {
      return this.mediaItem.mimetype.includes("powerpoint") || this.mediaItem.mimetype.includes("officedocument.presentationml.presentation");
    },
    // Set the wanted icon name, if any
    iconName() {
      // Don't show the icon if there is a thumbnail already
      if (this.hasTumbnail) {
        return "";
      }

      if (this.isPPT) {
        return "ppt";
      }

      return "";
    },
    backgroundImage() {
      if (this.isVideo) {
        return "";
      }

      if (!this.hasTumbnail) {
        return this.fallbackImage;
      }

      return this.mediaItem.thumbnailUrl;
    },
    hasTumbnail() {
      if (
        this.mediaItem.thumbnailUrl.includes(".srt") ||
        this.mediaItem.thumbnailUrl.includes(".tif")
      ) {
        return false;
      }
      return this.mediaItem.thumbnailUrl !== "";
    },
    singleDownloadUrl() {
      return this.mediaItem.downloads.length === 1 ? this.downloads[0].url : "";
    },
    downloads() {
      if (!(this.mediaItem && this.mediaItem.downloads)) {
        return [];
      }

      return this.mediaItem.downloads.map(({ url, label, size }) => ({
        url,
        size: `${this.$t(label)} (${size})`,
      }));
    },
  },
  methods: {
    play() {
      const poster = this.mediaItem.thumbnailUrl;
      const src = this.mediaItem.streamUrl;
      const video =
        '<div class="video-popup"><video preload="metadata" controls disablePictureInPicture controlsList="nodownload" class="video-popup__video" controls autoPlay poster="' +
        poster +
        '" > <source src="' +
        src +
        '"> Your browser does not support HTML5 video tag. </video></div>';
      $.magnificPopup.open({
        removalDelay: 300,
        mainClass: "mfp-fade",
        items: {
          src: video,
          type: "inline",
        },
      });
    },
    closeModal() {
      this.$emit("closeTermsModal");
    },
    termsCheck(file) {
      this.$emit("openTermsModal", file);
    },
  },
};



// WEBPACK FOOTER //
// ./assets/_js/components/skyfish-media/skyfish-media.js